export const getFormattedDetailsLink = (
  name: string,
  detailsLink: string,
  id: string,
) => {
  const sanitizedName = name
    .trim()
    .normalize("NFD") // Decompose accented characters (e.g. è -> e`)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-"); // Replace all non-alphanumeric characters with hyphens

  return detailsLink
    .replace("{OPERATOR_ID}", id)
    .replace("{OPERATOR_NAME}", sanitizedName)
    .replace("{EVENT_ID}", id)
    .replace("{EVENT_NAME}", sanitizedName)
    .replace("{ID}", id)
    .replace("{NAME}", sanitizedName);
};
